import CampaignsPage from "./CampaignsPage"
import CampaignUpdatePage from "./CampaignUpdatePage"

export default CampaignsPage

export {
  CampaignsPage,
  CampaignUpdatePage
}
